export default __webpack_public_path__ + "static/media/radio_button_marked.2140f7e0.svg";